import React from 'react'
import { useSelector } from 'react-redux'
import _ from 'lodash'

import CircularProgress from '@material-ui/core/CircularProgress'

import { CircularProgressBar } from 'ui/components'

import { ConsultStatusIcon } from 'utils/icons'
import serviceStatusConstants from 'utils/constants/serviceStatus'
import { formatDate, formatDocNumber } from 'utils/masks'

export default ({ docList = [], loading = false, onClickItem }) => {

  const panelEnv = useSelector((state) => state.auth.panelEnv)

  const renderCircularBar = (doc) => {
    const serviceInfos = doc.service_infos

    const processingCount = _.reject(
      serviceInfos,
      { status: serviceStatusConstants.SERVICE_STATUS.processing },
    ).length

    const progressCount = serviceInfos.length === 0
      ? 0
      : processingCount * 100 / serviceInfos.length
    if (progressCount === 100) return null

    return <CircularProgressBar value={progressCount} />
  }

  const renderDocProgress = (doc) => {
    const elemCircular = renderCircularBar(doc)
    if (!_.isEmpty(elemCircular)) return elemCircular

    return <ConsultStatusIcon consult={doc} />
  }

  const handleClick = (docItem) => {
    if (onClickItem) onClickItem(docItem)
  }

  return (
    <React.Fragment>
      {loading
      ? <tr className="disabled"><td colSpan={3}><CircularProgress /></td></tr>
      : (
        docList.length === 0 ? (
          <tr>
            <td colSpan={3}>Nenhum registro encontrado</td>
          </tr>
        ) : (
          <React.Fragment>
            {docList.map((docItem) => (
              <tr
                key={docItem.doc_id}
                className="handler"
                onClick={() => handleClick(docItem)}
              >
                <td>{formatDocNumber(docItem[panelEnv], panelEnv)}</td>
                <td>{formatDate(docItem.created_at)}</td>
                <td>{renderDocProgress(docItem)}</td>
              </tr>
            ))}
          </React.Fragment>
        )
      )}
    </React.Fragment>
  )
}
